export default __webpack_public_path__ + "static/Mikhail-9a4442b0412a0758ea376470d0ab38cb.png";